// ── Filter state used by the filter modal and page ─────────────────

export interface SettlementApiFilterValues {
  commodityId: string;
  customerId: string;
  serialSettlementNbrs: string;
  serialAdvanceNbrs: string;
}

export const DEFAULT_SETTLEMENT_FILTER_VALUES: SettlementApiFilterValues = {
  commodityId: "",
  customerId: "",
  serialSettlementNbrs: "",
  serialAdvanceNbrs: "",
};

export const DEFAULT_PAGE_SIZE = 100;
